import { Component, Input } from '@angular/core';
import { ParkInterface } from '@app/app/shared/interfaces/park.interface';

@Component({
  templateUrl: './park-list.html',
  selector: 'park-list'
})
export class ParkListComponent {
  @Input() parks: ParkInterface[];
}



// WEBPACK FOOTER //
// ./src/app/dashboard/parks/park-list/park-list.component.ts